<template>
  <div>
    <div v-for="(item, index) in issue.items" :key="item.id" class="mb-3 last:mb-0">
      <div v-html="item.content.richText" v-if="!issue.showUnknown"></div>
      <div v-else class="unknown-wrap" :style="{ paddingRight: wrapPaddingRight }">
        <div v-html="item.content.richText"></div>
        <div class="unknown-box">
          <van-radio-group :value="item.selectUnknown">
            <van-radio :name="true" @click="item.selectUnknown = true">
              <span class="text-theme-black-650">{{ issue.unknownText }}</span>
              <template v-slot:icon="{ checked }">
                <icon-radio :value="checked" />
              </template>
            </van-radio>
          </van-radio-group>
        </div>
      </div>
      <div>
        <w-slider
          :min="item.min"
          :max="item.max"
          v-model="item.value"
          show-input
          :show-graticule="issue.showGraticule"
          :graticule="issue.graticule"
          @change="item.selectUnknown = false"
        />
      </div>
    </div>
    <div v-if="issue.showSum" class="mt-5 text-right">加总值：{{ sum }}</div>
  </div>
</template>

<script>
import WSlider from '@/questions/components/WSlider'
import IconRadio from '@/components/base/IconRadio'

export default {
  name: 'Total',
  components: { IconRadio, WSlider },
  changeExpr: "sum",
  computed: {
    sum() {
      return this.issue.getSum()
    },
    wrapPaddingRight() {
      return Math.max(this.issue.unknownText.length * 20, 30) + 'px'
    }
  }
}
</script>
